var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompany01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.233398 15.7098L7.73041 12.373L12.0456 14.8756L12.9173 23.0857L7.59967 23.0417L8.38422 17.3342L7.46889 16.8073L2.97938 20.3199L0.233398 15.7098Z",
    fill: "#B4C0D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5254 14.5245L19.1508 19.3978L21.766 14.7001L16.4481 12.5488V11.4951L21.766 9.29988L19.1508 4.646L12.5254 9.51941V14.5245Z",
    fill: "#00D3AB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0456 9.12419L12.9173 0.914062L7.59967 1.00185L8.38422 6.70945L7.46889 7.2363L2.9358 3.72393L0.233398 8.28999L7.73041 11.6267L12.0456 9.12419Z",
    fill: "#4876EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany01);
export default __webpack_public_path__ + "static/media/company-01.c72e4838e3019f98a3be34ff0654728b.svg";
export { ForwardRef as ReactComponent };